import { Action } from 'redux';
import { Customer } from 'types/Customer';

export const CUSTOMER_RESET = 'customer/reset';
export const CUSTOMER_REQUEST_AUTH_CODE_START = 'customer/request_auth_code_start';
export const CUSTOMER_REQUEST_AUTH_CODE_SUCCESS = 'customer/request_auth_code_success';
export const CUSTOMER_AUTHENTICATE_BY_CODE_START = 'customer/authenticate_by_code_start';
export const CUSTOMER_AUTHENTICATE_BY_CODE_SUCCESS = 'customer/authenticate_by_code_success';
export const CUSTOMER_ERROR = 'customer/error';

interface CustomerResetAction extends Action<typeof CUSTOMER_RESET> {}

interface CustomerRequestAuthenticationCodeStartAction
    extends Action<typeof CUSTOMER_REQUEST_AUTH_CODE_START> {}
interface CustomerRequestAuthenticationCodeSuccessAction
    extends Action<typeof CUSTOMER_REQUEST_AUTH_CODE_SUCCESS> {}

interface CustomerAuthenticateByCodeStartAction
    extends Action<typeof CUSTOMER_AUTHENTICATE_BY_CODE_START> {}
interface CustomerAuthenticateByCodeSuccessAction
    extends Action<typeof CUSTOMER_AUTHENTICATE_BY_CODE_SUCCESS> {
    payload: {
        customer: Customer;
    };
}

interface CustomerErrorAction extends Action<typeof CUSTOMER_ERROR> {}

export type CustomerAction =
    | CustomerResetAction
    | CustomerRequestAuthenticationCodeStartAction
    | CustomerRequestAuthenticationCodeSuccessAction
    | CustomerAuthenticateByCodeStartAction
    | CustomerAuthenticateByCodeSuccessAction
    | CustomerErrorAction;
